import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableSortLabel } from "@/components/atoms/TableSortLabel";
import {
  ChargerSupplyDays,
  ChargerSupplyDaysSortKey,
  ChargerSupplyDaysOrderTypes,
} from "@/models/chargeSupplyDays";
import { TableContainer } from "@mui/material";
import { ChargeSupplyDayConstants } from "./ChargeSupplyDaysConstants";
import { formatKwh } from "@/util";

export type chargeSupplyDaysListProps = {
  chargerSupplyDays: ChargerSupplyDays[];
  orderTypes: ChargerSupplyDaysOrderTypes;
  onClickChangeSort: (key: ChargerSupplyDaysSortKey) => void;
};

export const ChargeSupplyDayList = (props: chargeSupplyDaysListProps) => {
  const { chargerSupplyDays, orderTypes, onClickChangeSort } = props;

  return (
    <React.Fragment>
      <TableContainer>
        <Table size="small">
          <TableHead className="list-head">
            <TableRow>
              <TableCell width="40%">
                {ChargeSupplyDayConstants.OfficeName}
              </TableCell>
              <TableCell width="20%">
                {ChargeSupplyDayConstants.TargetDatetime}
                <TableSortLabel
                  active={
                    chargerSupplyDays.length && !!orderTypes.targetAt
                      ? true
                      : false
                  }
                  direction={orderTypes.targetAt === "desc" ? "desc" : "asc"}
                  sx={{ ":hover": { color: "red" } }}
                  onClick={() => onClickChangeSort("targetAt")}
                />
              </TableCell>
              <TableCell width="30%" align="right">
                {ChargeSupplyDayConstants.ChargeElectricPower}
              </TableCell>
              <TableCell width="10%" />
            </TableRow>
          </TableHead>
          <TableBody>
            {chargerSupplyDays.map((row, index) => (
              <TableRow
                key={(row.displayName || "") + index}
                hover
                sx={{ wordBreak: "break-all" }}
              >
                <TableCell>{row.displayName}</TableCell>
                <TableCell>{row.targetAt?.replaceAll("-", "/")}</TableCell>
                <TableCell sx={{ textAlign: "right" }}>
                  {formatKwh(row.chargeKwh ?? NaN)}
                </TableCell>
                <TableCell />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};
